import { CollectionPaymentTypes, TransactionPaymentType, TransactionStatus } from "@gtpl/shared-models/common-models"

export class CollectionsReq{
    bankCharges : number;
    buyerId : number;
    bankId : number;
    buyerShortPayment : number;
    // dueAmt : number;
    dueDate : Date|string;
    eta : Date|string;
    etd : Date|string;
    invAmt : number;
    invNum : string;
    paymentTermsId : number;
    poNum : string;
    recievedAmt : number;
    soId : number;
    recievedDate : Date|string;
    transactionStatus : TransactionStatus
    transactionType : TransactionPaymentType
    remarks : string;
    createdUser : string;
    unitId:number
    payment:CollectionPaymentTypes
    receivedAmountInr?:number
    exchangeRate?:number
    advance?:boolean
    advanceAmount?:number
    receivedBankName?:string
 constructor(
    bankCharges : number,
    buyerId : number,
    bankId : number,
    buyerShortPayment : number,
    // dueAmt : number,
    dueDate : Date|string,
    eta : Date|string,
    etd : Date |string,
    invAmt : number,
    invNum : string,
    paymentTermsId : number,
    poNum : string,
    recievedAmt : number,
    soId : number,
    recievedDate : Date |string,
    transactionStatus : TransactionStatus,
    transactionType : TransactionPaymentType,
    remarks : string,
    createdUser : string,
    unitId:number,
    payment:CollectionPaymentTypes,
    receivedAmountInr?:number,
    exchangeRate?:number,
    advance?:boolean,
    advanceAmount?:number,
    receivedBankName?:string

 ){
    this.bankCharges = bankCharges
    this.bankId = bankId
    this.buyerId = buyerId
    this.buyerShortPayment = buyerShortPayment
    this.createdUser = createdUser
// this.dueAmt = dueAmt
this.dueDate=dueDate
this.eta=eta
this.etd=etd
this.invAmt =  invAmt
this.invNum = invNum
this.paymentTermsId = paymentTermsId
this.poNum = poNum
this.recievedAmt = recievedAmt
this.soId = soId
this.recievedDate =recievedDate
this.transactionStatus = transactionStatus
this.transactionType =transactionType
this.remarks =remarks
this.payment = payment
this.unitId = unitId
this.receivedAmountInr = receivedAmountInr
this.exchangeRate = exchangeRate
this.advance = advance
this.advanceAmount = advanceAmount
this.receivedBankName = receivedBankName
 }
}
export class DdbCollectionsReq{
   buyerId : number;
   invAmt : number;
   invNum : string;
   recievedAmt : number;
   soId : number;
   recievedDate : Date|string;
   shippingBillNo : string;
   shippingBillDate : Date|string;
   remarks : string;
   createdUser : string;
   unitId:number
   payment:CollectionPaymentTypes
   receivedAmountInr?:number
   exchangeRate?:number
   poNum?:string
constructor(
   buyerId : number,
   invAmt : number,
   invNum : string,
   recievedAmt : number,
   soId : number,
   recievedDate : Date|string,
   shippingBillNo : string,
   shippingBillDate : Date|string,
   remarks : string,
   createdUser : string,
   unitId:number,
   payment:CollectionPaymentTypes,
   receivedAmountInr?:number,
   exchangeRate?:number,
   poNum?:string


){
   this.buyerId = buyerId
   this.shippingBillDate = shippingBillDate
   this.createdUser = createdUser
this.shippingBillNo=shippingBillNo
this.invAmt =  invAmt
this.invNum = invNum
this.recievedAmt = recievedAmt
this.soId = soId
this.recievedDate =recievedDate
this.remarks =remarks
this.payment = payment
this.unitId = unitId
this.receivedAmountInr = receivedAmountInr
this.exchangeRate = exchangeRate
this.poNum = poNum

}
}
export class CollectionIdRequest{
   collectionId: number
   liscenceNum ?:string
   constructor(collectionId:number,liscenceNum ?:string
   ){
      this.collectionId = collectionId
      this.liscenceNum = liscenceNum

   }
}
export class IgstCollectionsReq{
   buyerId : number;
   invAmt : number;
   invNum : string;
   recievedAmt : number;
   soId : number;
   recievedDate : Date|string;
   shippingBillNo : string;
   shippingBillDate : Date|string;
   remarks : string;
   createdUser : string;
   unitId:number
   payment:CollectionPaymentTypes
   receivedAmountInr?:number
   exchangeRate?:number
   poNum?:string
   
constructor(
   buyerId : number,
   invAmt : number,
   invNum : string,
   recievedAmt : number,
   soId : number,
   recievedDate : Date|string,
   shippingBillNo : string,
   shippingBillDate : Date|string,
   remarks : string,
   createdUser : string,
   unitId:number,
   payment:CollectionPaymentTypes,
   receivedAmountInr?:number,
   exchangeRate?:number,
   poNum?:string


){
   this.buyerId = buyerId
   this.shippingBillDate = shippingBillDate
   this.createdUser = createdUser
this.shippingBillNo=shippingBillNo
this.invAmt =  invAmt
this.invNum = invNum
this.recievedAmt = recievedAmt
this.soId = soId
this.recievedDate =recievedDate
this.remarks =remarks
this.payment = payment
this.unitId = unitId
this.receivedAmountInr = receivedAmountInr
this.exchangeRate = exchangeRate
this.poNum = poNum
}
}

export class IgstReportReq{
   
   invNum : string;
   unitId:number
   partyName:number
   financeYear:string
   fromDate : string
   toDate : string
constructor(
   invNum : string,
   unitId:number,
   partyName:number,
   financeYear:string,
   fromDate : string,
   toDate : string
){
this.invNum = invNum
this.unitId = unitId
this.partyName = partyName
this.financeYear = financeYear
this.fromDate = fromDate
this.toDate = toDate

}
}